export class MathUtils {
  static round(nbr: number, precision: number = 2): number {
    return +(Math.round(Number(`${nbr.toFixed(13)}e+${precision}`))  + `e-${precision}`);
  }
}
